import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className="note">
      <span className="bold">Note:</span> You must be using npm version 2 or greater to use scopes. To upgrade to the latest version of npm, on the command line, run <code className="highlighter-rouge">npm install npm@latest -g</code>
    </div>
    <p>{`When you sign up for an npm user account or create an organization, you are granted a scope that matches your user or organization name. You can use this scope as a namespace for related packages.`}</p>
    <p>{`A scope allows you to create a package with the same name as a package created by another user or organization without conflict.`}</p>
    <p>{`When listed as a dependent in a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file, scoped packages are preceded by their scope name. The scope name is everything between the `}<inlineCode parentName="p">{`@`}</inlineCode>{` and the slash:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`"npm" scope:`}</strong></li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`@npm/package-name
`}</code></pre>
    <ul>
      <li parentName="ul"><strong parentName="li">{`"npmcorp" scope:`}</strong></li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`@npmcorp/package-name
`}</code></pre>
    <p>{`To create and publish public scoped packages, see "`}<a parentName="p" {...{
        "href": "creating-and-publishing-scoped-public-packages"
      }}>{`Creating and publishing scoped public packages`}</a>{`".`}</p>
    <p>{`To create and publish private scoped packages, see "`}<a parentName="p" {...{
        "href": "creating-and-publishing-private-packages"
      }}>{`Creating and publishing private packages`}</a>{`".`}</p>
    <h2>{`Scopes and package visibility`}</h2>
    <ul>
      <li parentName="ul">{`Unscoped packages are always public.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "about-private-packages"
        }}>{`Private packages`}</a>{` are always scoped.`}</li>
      <li parentName="ul">{`Scoped packages are private by default; you must pass a command-line flag when publishing to make them public.`}</li>
    </ul>
    <p>{`For more information on package scope and visibility, see "`}<a parentName="p" {...{
        "href": "package-scope-access-level-and-visibility"
      }}>{`Package scope, access level, and visibility`}</a>{`".`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      